<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="can('write_order_channel_types')">
      <router-link class="btn btn-success" :to="{ name: 'order_channel_type_create' }" tag="button">{{
        'routes_order_channel_type_create' | t
      }}</router-link>
    </div>
    <lazy-table v-model="order_channel_types" model="order_channel_types" ref="table">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'name' | t }}</th>
            <th>{{ 'support_url' | t }}</th>
            <th>{{ 'uses_scheduled_import' | t }}</th>
            <th>{{ 'supports_id_import' | t }}</th>
            <th>{{ 'supports_statuses_import' | t }}</th>
            <th>{{ 'supports_time_interval_import' | t }}</th>
          </tr>
        </thead>
        <tbody>
          <router-link
            :to="{ name: 'order_channel_type', params: { order_channel_type_id: channel.id } }"
            tag="tr"
            v-for="channel in order_channel_types"
            :key="channel.id"
            role="button"
          >
            <td>{{ channel.name }}</td>
            <td>{{ channel.support_url }}</td>
            <td class="text-center">
              <i class="fa fa-check" v-align="center" v-if="channel.uses_scheduled_import"></i>
            </td>
            <td class="text-center"><i class="fa fa-check" v-if="channel.supports_id_import"></i></td>
            <td class="text-center"><i class="fa fa-check" v-if="channel.supports_statuses_import"></i></td>
            <td class="text-center"><i class="fa fa-check" v-if="channel.supports_time_interval_import"></i></td>
          </router-link>
        </tbody>
      </table>
    </lazy-table>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      order_channel_types: []
    };
  },
  methods: {}
};
</script>

<style scoped></style>
